module.exports = __webpack_public_path__ + "static/zoppay-938610e9df0a597f7ed36d33787c7d60.png";